interface Props {
  className?: string;
  fill?: string;
}

const BackspaceFilledIcon = ({ className, fill, ...rest }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 14"
    className={className || "w-5 h-5"}
    {...rest}
  >
    <path
      fill="currentColor"
      d="M14.274 7.007c0 2.86-2.263 5.178-5.055 5.178S4.163 9.867 4.163 7.007s2.264-5.18 5.056-5.18 5.055 2.32 5.055 5.18"
    />
    <path
      fill={fill}
      d="M13.773 14q1.11 0 1.668-.572.56-.565.559-1.687V2.26q0-1.122-.559-1.687Q14.882 0 13.773 0H7.317a4 4 0 0 0-.8.077q-.37.07-.703.256-.332.177-.627.487L.657 5.6q-.227.24-.378.472-.143.225-.211.448a1.57 1.57 0 0 0 .09 1.145q.159.34.499.704l4.538 4.71q.294.31.62.511.331.201.701.302.378.1.808.1zm-7.098-3.744a.48.48 0 0 1-.347-.139.5.5 0 0 1-.136-.356.5.5 0 0 1 .143-.355l2.34-2.398-2.34-2.398a.5.5 0 0 1-.143-.356q0-.21.136-.348a.48.48 0 0 1 .347-.14q.211 0 .347.156l2.34 2.39 2.357-2.398a.45.45 0 0 1 .34-.155q.203 0 .34.147a.46.46 0 0 1 .143.34.5.5 0 0 1-.144.356L10.05 7.008l2.34 2.39q.144.163.144.363a.5.5 0 0 1-.143.356.46.46 0 0 1-.34.14.5.5 0 0 1-.355-.155l-2.333-2.39-2.326 2.39a.5.5 0 0 1-.362.154"
    />
  </svg>
);

export default BackspaceFilledIcon;
